import logService from '../../services/wss/logService3';
import userStateService from '../../services/UserStateService';
import responseHelper from '../../services/ResponseHelper';
import AppContext from '../AppContext';
import EngineBase2 from '../../services/engines/EngineBase2';
import userStateFetcher from './UserStateFetcher';
import ComponentNotifier from '../../services/wss/ComponentNotifier';
import { EngineNames } from '../../services/wss/events/EngineNames';

import userStateCache from './UserStateCache2';

const _name = EngineNames.UserStateEngine2;

class UserStateEngine2 extends EngineBase2 {
    /**
     * Initializes cache. Called from PageContent on login, after bootup of UserStateEngine.
     */
    bootup = () => {
        try {
            this.initialize(_name, userStateCache);

            this._tabId = AppContext.getTabId();
            this._uid = AppContext.getUid();
        } catch (error) {
            logService.logError(`${_name}.bootup: error=${error.message}`);
        }
    };

    /**
     * Fetches all UserState2 entries for the current user via REST.
     * Fills cache directly — replaces reliance on the SignalR restore push during bootup.
     */
    fetchAll = async () => {
        const items = await userStateFetcher.fetch();
        if (!items) return;
        userStateCache.upsertAll(items);
        ComponentNotifier.notify(_name, 'restored');
    };

    /**
     * Returns the value for a named state entry for the current tab.
     * @param {string} name
     * @returns {string|null}
     */
    getValue = (name) => {
        return userStateCache.getValue(name);
    };

    /**
     * Upserts one or more state entries to cache and persists to BE.
     * Cache is updated immediately; RK is filled in after BE response.
     * @param {object[]} entries - array of { name, value } — rk and tabId are filled in here
     */
    set = async (entries) => {
        try {
            const now = Date.now();

            const items = entries.map((e) => {
                const existing = userStateCache.getByTabIdAndName(this._tabId, e.name);
                return {
                    rk: existing?.rk ?? null, // null = new entry, BE generates RK
                    uid: this._uid,
                    tabId: this._tabId,
                    name: e.name,
                    value: String(e.value ?? ''),
                    ems: now,
                };
            });

            // Update cache immediately so getValue() works without waiting for BE
            userStateCache.upsertAll(items);

            const dto = { data: items };
            const resp = await userStateService.postUserState(dto);
            const code = responseHelper.check(resp, 'postUserState', _name);
            if (code !== 200) {
                return;
            }

            // Upsert again with BE-generated RKs
            // for new items
            if (resp.data.items.length === 0) {
                return;
            }

            userStateCache.upsertAll(resp.data.items);
        } catch (error) {
            logService.logError(`${_name}.set: error=${error.message}`);
        }
    };
}

const userStateEngine2 = new UserStateEngine2();
export default userStateEngine2;
